// VitaGreen P01 (Claude): gestaffelte Reveals unterhalb des Hero.
// Nur Klassen setzen, die Bewegung selbst ist CSS (transform/opacity).
(() => {
  const items = document.querySelectorAll('.vgc [data-vgc-reveal]');
  if (!items.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );
  items.forEach((el) => {
    // Elemente, die beim Laden schon im Bild sind, nicht erst verstecken (kein Flackern, kein CLS)
    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) { el.classList.add('is-in'); return; }
    io.observe(el);
  });
  document.documentElement.classList.add('vgc-js');
})();
